import * as actions from './mushroomActions';

const initialState = {
  mushroomContexts: [],
  loading: false,
  error: null,
  currentMushroom: null,
  loadingMushroomDetail: false,
  errorMushroomDetail: null,
  creatingVariety: false,
  createVarietyError: null,
  creatingHybrid: false,
  createHybridError: null,
  updatingContext: false,
  deletingContext: false,
  uploadingImage: false,
  contextSuccess: null,
  contextError: null,
  speciesSpawnLineage: null,
  loadingSpeciesSpawnLineage: false,
  errorSpeciesSpawnLineage: null,
};

export default function mushroomReducer(state = initialState, action) {
  switch (action.type) {
    case actions.FETCH_MUSHROOM_CONTEXTS.REQUEST:
      return { ...state, loading: true, error: null };

    case actions.FETCH_MUSHROOM_CONTEXTS.SUCCESS:
      return { ...state, mushroomContexts: action.payload, loading: false };

    case actions.FETCH_MUSHROOM_CONTEXTS.FAILURE:
      return { ...state, error: action.payload, loading: false };

    // Fetch Mushroom Detail
    case actions.FETCH_MUSHROOM_DETAIL.REQUEST:
      return { ...state, loadingMushroomDetail: true, errorMushroomDetail: null };

    case actions.FETCH_MUSHROOM_DETAIL.SUCCESS:
      return { ...state, currentMushroom: action.payload, loadingMushroomDetail: false };

    case actions.FETCH_MUSHROOM_DETAIL.FAILURE:
      return { ...state, errorMushroomDetail: action.payload, loadingMushroomDetail: false };

    case actions.CLEAR_MUSHROOM_DETAIL:
      return { ...state, currentMushroom: null, errorMushroomDetail: null };

    // Create Variety
    case actions.CREATE_MUSHROOM_VARIETY.REQUEST:
      return { ...state, creatingVariety: true, createVarietyError: null };

    case actions.CREATE_MUSHROOM_VARIETY.SUCCESS:
      return {
        ...state,
        creatingVariety: false,
        mushroomContexts: [...state.mushroomContexts, action.payload],
      };

    case actions.CREATE_MUSHROOM_VARIETY.FAILURE:
      return { ...state, creatingVariety: false, createVarietyError: action.payload };

    // Create Hybrid
    case actions.CREATE_MUSHROOM_HYBRID.REQUEST:
      return { ...state, creatingHybrid: true, createHybridError: null };

    case actions.CREATE_MUSHROOM_HYBRID.SUCCESS:
      return {
        ...state,
        creatingHybrid: false,
        mushroomContexts: [...state.mushroomContexts, action.payload],
      };

    case actions.CREATE_MUSHROOM_HYBRID.FAILURE:
      return { ...state, creatingHybrid: false, createHybridError: action.payload };

    // Update Mushroom Context
    case actions.UPDATE_MUSHROOM_CONTEXT.REQUEST:
      return { ...state, updatingContext: true, contextError: null, contextSuccess: null };

    case actions.UPDATE_MUSHROOM_CONTEXT.SUCCESS:
      return {
        ...state,
        updatingContext: false,
        contextSuccess: 'Variety updated successfully',
        mushroomContexts: state.mushroomContexts.map((ctx) =>
          ctx.id === action.payload.id ? action.payload : ctx
        ),
      };

    case actions.UPDATE_MUSHROOM_CONTEXT.FAILURE:
      return { ...state, updatingContext: false, contextError: action.payload };

    // Delete Mushroom Context
    case actions.DELETE_MUSHROOM_CONTEXT.REQUEST:
      return { ...state, deletingContext: true, contextError: null, contextSuccess: null };

    case actions.DELETE_MUSHROOM_CONTEXT.SUCCESS:
      return {
        ...state,
        deletingContext: false,
        contextSuccess: 'Variety deleted successfully',
        mushroomContexts: state.mushroomContexts.filter((ctx) => ctx.id !== action.payload),
      };

    case actions.DELETE_MUSHROOM_CONTEXT.FAILURE:
      return { ...state, deletingContext: false, contextError: action.payload };

    // Upload Mushroom Image
    case actions.UPLOAD_MUSHROOM_IMAGE.REQUEST:
      return { ...state, uploadingImage: true, contextError: null };

    case actions.UPLOAD_MUSHROOM_IMAGE.SUCCESS:
      return {
        ...state,
        uploadingImage: false,
        contextSuccess: 'Image uploaded successfully',
        mushroomContexts: state.mushroomContexts.map((ctx) =>
          ctx.id === action.payload.id ? action.payload : ctx
        ),
      };

    case actions.UPLOAD_MUSHROOM_IMAGE.FAILURE:
      return { ...state, uploadingImage: false, contextError: action.payload };

    // Species Spawn Lineage
    case actions.FETCH_SPECIES_SPAWN_LINEAGE.REQUEST:
      return { ...state, loadingSpeciesSpawnLineage: true, errorSpeciesSpawnLineage: null };

    case actions.FETCH_SPECIES_SPAWN_LINEAGE.SUCCESS:
      return { ...state, speciesSpawnLineage: action.payload, loadingSpeciesSpawnLineage: false };

    case actions.FETCH_SPECIES_SPAWN_LINEAGE.FAILURE:
      return { ...state, errorSpeciesSpawnLineage: action.payload, loadingSpeciesSpawnLineage: false };

    case actions.CLEAR_SPECIES_SPAWN_LINEAGE:
      return { ...state, speciesSpawnLineage: null, errorSpeciesSpawnLineage: null };

    default:
      return state;
  }
}
